import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../Assets/CSS/AdminDashboard.css";
import { useNavigate } from "react-router-dom";
import profileImg from "../../Assets/Images/profile.jpg";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import Layout from "../../Components/Layout";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";




// Custom button for DatePicker
const CustomDateButton = React.forwardRef(({ value, onClick }, ref) => (
  <div className="date-picker-btn" ref={ref}>
    <span>{value}</span>
    <Icon
      icon="mdi:chevron-down"
      width="20"
      height="20"
      className="dropdown-icon"
      onClick={onClick}
      style={{ cursor: "pointer", marginLeft: "1px" }}
    />
  </div>
));

const CustomTooltip = ({ active, payload, label, selectedDate }) => {
  if (active && payload && payload.length) {
    const selectedMonth = selectedDate.toLocaleString("default", {
      month: "short",
    });
    const selectedYear = selectedDate.getFullYear();

    return (
      <div
        className="custom-tooltip"
        style={{
          background: "#fff",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "6px",
        }}
      >
        <p>
          <strong>Employee Attend - {`${payload[0].value}`}</strong> | {selectedMonth} {label}
        </p>
      </div>
    );
  }
  return null;
};

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [formdata, setFormdata] = useState();
  const [employee, setEmployees] = useState();
  const [attendanceData, setAttendanceData] = useState([]);
  const [todayAttendance, setTodayAttendance] = useState(null);
  const year = selectedDate.getFullYear();
  const month = selectedDate.toLocaleString("default", { month: "long" }); // ➤ "July"
  const [loading, setLoading] = useState(true);

  const featshadmindashboard = async () => {
    setLoading(true); // start skeleton
    try {
      const token = localStorage.getItem("token"); // Or however you're storing it
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/employees/attendance-summary/monthly`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            month: month, // e.g., "September"
            year: year,   // e.g., 2026
          },
        }
      );

      console.log("admindashboard", response.data);
      setFormdata(response.data);
    } catch (error) {
      console.error("Error fetching admin dashboard data:", error);
    } finally {
      setLoading(false); // stop skeleton
    }
  };

  const fetchTodayAttendance = async () => {
    try {
      const token = localStorage.getItem("token");
      const today = new Date().toISOString().split('T')[0]; // Format: YYYY-MM-DD

      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/employees/attendance-summary/daily`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            date: today,
          },
        }
      );

      console.log("Today's attendance", response.data);
      setTodayAttendance(response.data);
    } catch (error) {
      console.error("Error fetching today's attendance data:", error);
      setTodayAttendance(null);
    }
  };

  const featchEmployeeData = async () => {
    try {
      const token = localStorage.getItem("token"); // Or however you're storing it
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/employees/hired-this-month`,

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            year,
            month,
          },
        }
      );

      console.log("emp;o", response.data);
      setEmployees(response.data);
    } catch (error) {
      console.error("Error fetching leave records:", error);
    }
  };
  const featchEmployeeAttendanceMonthly = async () => {

    try {
      const token = localStorage.getItem("token"); // Or however you're storing it

      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/employees/attendance-summary/monthly`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            year,
            month, // Pass to backend
          },
        }
      );
      const rawData = response.data?.dailyAttendanceSummary || [];

      const formattedData = rawData.map((entry) => {
        const day = new Date(entry.date).getDate();
        return {
          day,
          emp: entry.punchInEmployees,
        };
      });

      setAttendanceData(formattedData);


      console.log("Attendance Monthly", formattedData);
      // setEmployees(response.data);
    } catch (error) {
      console.error("Error fetching attendance monthly data:", error);
    }
  };

  useEffect(() => {
    featshadmindashboard();
    featchEmployeeData();
    featchEmployeeAttendanceMonthly();
    fetchTodayAttendance();
  }, [selectedDate]);

  const handleViewEmployee = (empId) => {
    navigate("/employee-dashboard", { state: { empId } });

  };

  return (
    <Layout>
      <div className="backgound-main-content">
        <div className="text">
          <div className="stat-row">
            <div className="admin-stat-card" style={{ cursor: 'pointer' }}
              onClick={() => { navigate('/emp-management') }}>
              <div className="total-emps">
                <Icon icon="material-symbols:group-outline" className="icon" />
              </div>
              <div className="stat-info">
                <p className="stat-label">Total Employees</p>
                <p className="stat-value">
                  {/* {formdata?.totalEmployees} */}
                  {loading ? <Skeleton width={50} /> : formdata?.totalEmployees}
                </p>
              </div>
            </div>

            <div className="admin-stat-card" style={{ cursor: 'pointer' }}
              onClick={() => { navigate('/admin-timesheet') }}

            >
              <div className="admin-fingerp">
                <Icon icon="material-symbols:fingerprint" className="icon" />
              </div>
              <div className="stat-info">
                <p className="stat-label">Punched in Today</p>
                <p className="stat-value">
                  {loading ? <Skeleton width={50} /> : todayAttendance?.dailyAttendanceSummary?.[0]?.punchInEmployees || 0}
                </p>
              </div>
            </div>

            <div className="admin-stat-card">
              <div className="icon-absent">
                <Icon icon="material-symbols:group-outline" className="icon" />
              </div>
              <div className="stat-info">
                <p className="stat-label">Absent Today</p>
                <p className="stat-value">
                  {loading ? <Skeleton width={50} /> : todayAttendance?.dailyAttendanceSummary?.[0]?.absentEmployees || 0}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="admin-dashboard-row">
          {/* Chart Section */}
          <div className="admin-dashboard-chart-card">
            <div className="chart-header">
              <h3 className="chart-title">Monthly Attendance Trends</h3>
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                dateFormat="MMM yyyy"
                showMonthYearPicker
                customInput={<CustomDateButton />}
              />
            </div>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  height: 350,
                  gap: "4px",
                  padding: "0 10px",
                }}
              >
                {Array(30).fill(0).map((_, i) => (
                  <div
                    key={i}
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-end",
                      gap: "4px",
                    }}
                  >
                    {Array(3).fill(0).map((_, j) => (
                      <Skeleton
                        key={j}
                        width="100%"
                        height={`${Math.random() * 50 + 20}px`} // random heights for stacked effect
                        baseColor="#e0e0e0"
                        highlightColor="#f5f5f5"
                      />
                    ))}
                  </div>
                ))}
              </div>
            ) : (
              <ResponsiveContainer width="100%" height={350}>
                <AreaChart
                  data={attendanceData}
                  margin={{ top: 20, right: 20, left: 0, bottom: 5 }}
                >
                  <defs>
                    <linearGradient id="colorEmp" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#00AFEF" stopOpacity={0.8} />
                      <stop offset="95%" stopColor="#FFFFFF" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis
                    dataKey="day"
                    type="number"
                    domain={[1, 30]}
                    tickCount={6}
                    tick={{ fontSize: 12 }}
                  />
                  <YAxis
                    type="number"
                    domain={[0, 30]}
                    ticks={[0, 5, 10, 15, 20, 25, 30]}
                    tick={{ fontSize: 12 }}
                  />
                  <Tooltip
                    content={<CustomTooltip selectedDate={selectedDate} />}
                  />
                  <Area
                    type="monotone"
                    dataKey="emp"
                    stroke="#2563eb"
                    fill="url(#colorEmp)"
                    strokeWidth={2}
                    activeDot={{ r: 6 }}
                  />
                </AreaChart>
              </ResponsiveContainer>
            )}
          </div>

          {/* New Employees Section */}
          <div className="admin-new-employees-card">
            <div className="admin-card-header">
              <h2 className="admin-card-title">New Employees This Month</h2>
              <button
                className="admin-add-employee-btn"
                onClick={() => navigate("/emp-management")}
              >
                + Employee
              </button>

            </div>

            <div className="admin-employee-list">
              {loading
                ? Array(3).fill("").map((_, i) => (
                  <div className="admin-employee-item" key={i}>
                    <Skeleton circle={true} width={50} height={50} />
                    <div className="admin-employee-info" style={{ marginLeft: "10px" }}>
                      <Skeleton width={100} height={20} />
                      <Skeleton width={150} height={15} style={{ marginTop: "5px" }} />
                    </div>
                  </div>
                ))
                :
                employee?.map((employee) => (
                  <div className="admin-employee-item" key={employee.id}>
                    <img
                      src={require("../../Assets/Images/man.png")}
                      // src={employee.image}
                      alt={employee.firstName}
                      className="admin-employee-img"


                    />
                    <div className="admin-employee-info">
                      <p className="admin-employee-name px-1">  {`${employee.firstName} ${employee.lastName}`}</p>
                      <p className="admin-employee-email">
                        {employee.officeEmail}
                      </p>
                    </div>

                    <div className="icon-b">
                      <button
                        className="view-btn"
                        onClick={() => handleViewEmployee(employee.empId)}
                      >
                        <Icon
                          icon="mdi:eye-outline"
                          className="admin-admin-eye-icon"
                        />
                      </button>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AdminDashboard;
